<template>
<div>
  <template>
  <v-row align="center">
    <v-col cols="12">
      <v-select
        :items="func"
        v-model="data"
        :menu-props="{ top: true, offsetY: true }"
        label="Data aggregation function"

        @change="method_1"
      ></v-select>
    </v-col>
  </v-row>
  </template>
</div>
</template>

<script>
export default {
    name: 'data_function',

    components: {
  },
  data(){
       return {
        data: 'none',
         func: ['average', 'max', 'min', 'sum','none'],   
        //  data:'',
       }
    },
    beforeMount()
    {
          // this.data = sessionStorage.getItem("data_function",this.data) || '';

    },
    methods:{
         method_1(){
         this.$emit('data_function',this.data);
    sessionStorage.setItem("data_function",this.data);
    console.log('props',this.function)
        //  console.log('checking data fun',this.data)
      }
}
};

</script>